var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59317 4.72168C10.9179 4.72899 11.6354 4.78807 12.1032 5.25584C12.6385 5.79122 12.6385 6.65245 12.6385 8.37492V8.98399C12.6385 10.7071 12.6385 11.5683 12.1032 12.1037C11.5684 12.6384 10.7066 12.6384 8.98409 12.6384H4.11148C2.38902 12.6384 1.52718 12.6384 0.992409 12.1037C0.457031 11.5677 0.457031 10.7071 0.457031 8.98399V8.37492C0.457031 6.65245 0.457031 5.79122 0.992409 5.25584C1.46018 4.78807 2.17767 4.72899 3.50241 4.72168",
    stroke: "#262F5F",
    strokeWidth: 0.913613,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54793 0.457031V8.37501M6.54793 8.37501L4.7207 6.24325M6.54793 8.37501L8.37516 6.24325",
    stroke: "#262F5F",
    strokeWidth: 0.913613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOffer);
export default __webpack_public_path__ + "static/media/download-offer.7f7b496c3b791f193c5be592ae79222b.svg";
export { ForwardRef as ReactComponent };